module.exports = __webpack_public_path__ + "static/media/eg.cb98de29.svg";